import { render, staticRenderFns } from "./OtherResolution.vue?vue&type=template&id=630e75e0"
import script from "./OtherResolution.vue?vue&type=script&lang=js"
export * from "./OtherResolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports